import React from "react";

interface Props {
    direction?: "vertical" | "horizontal"
    spacing?: 1 | 2 | 3 | 4 | 5
}

export function Stack({
    direction = "vertical",
    spacing = 2,
    children,
}: React.PropsWithChildren<Props>) {
    return (
        <div
            style={{
                display: "flex",
                flexDirection: direction === "vertical" ? "column" : "row",
                gap: `${spacing * 10}px`
            }}
        >
            {children}
        </div>
    );
}
